import { useBrand } from "hooks/useBrand";
import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Paths from "routes/Paths";

import type { LegalConsentNoteProps } from "./legal-consent-note.types";

import styles from "./LegalConsentNote.module.css";

const LegalConsentNote = ({ action }: LegalConsentNoteProps) => {
	const { t } = useTranslation("accountsPage");
	const { brand } = useBrand();

	return (
		<p className={styles.note}>
			<Trans
				components={{
					privacy: <Link to={Paths.privacyPolicy} />,
					terms: <Link to={Paths.termsOfService} />
				}}
				i18nKey="legalConsent.note"
				ns="accountsPage"
				values={{ action: t(`legalConsent.actions.${action}`), brand }}
			/>
		</p>
	);
};

export default LegalConsentNote;
